import React from 'react';
import styled from 'styled-components';

const Layout = styled.div`
  display: flex;
  width: 100%;
  justify-content: ${(props) => (props.right ? 'flex-end' : 'flex-start')};
  flex-direction: column;
  text-align: ${(props) => (props.right ? 'end' : 'left')};
`;

const Title = styled.div`
  color: #707070;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

const Text = styled.div`
  color: #505050;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
`;

export const TitleAndText = ({ title, text, right }) => (
  <>
    <Layout right={right}>
      <Title>{title}</Title>
      <Text>{text}</Text>
    </Layout>
  </>
);

export default TitleAndText;
